import { OnInit, EventEmitter, ChangeDetectorRef } from '@angular/core';
var SortComponent = /** @class */ (function () {
    function SortComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.sortOptions = [];
        this.sortChange = new EventEmitter();
    }
    Object.defineProperty(SortComponent.prototype, "sort", {
        get: function () {
            return this._sort;
        },
        set: function (value) {
            this._sort = value;
            this.changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    SortComponent.prototype.ngOnInit = function () {
    };
    SortComponent.prototype.handleSort = function (option) {
        this.sortChange.emit(option);
    };
    return SortComponent;
}());
export { SortComponent };
